// Метрики сервера (CPU/RAM/диск) на странице статистики. Виден только администратору.

const STATUS_COLORS = {
  good: '#0ca30c',
  warning: '#fab219',
  serious: '#ec835a',
  critical: '#d03b3b',
};

const POLL_INTERVAL_MS = 5000;
let pollTimer = null;

function formatBytes(bytes) {
  if (!bytes && bytes !== 0) return '—';
  const gb = bytes / (1024 ** 3);
  return `${gb.toFixed(1)} ГБ`;
}

function formatUptime(seconds) {
  if (!seconds && seconds !== 0) return '—';
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (days > 0) return `${days} дн ${hours} ч`;
  if (hours > 0) return `${hours} ч ${minutes} мин`;
  return `${minutes} мин`;
}

function updateMeter(prefix, percent, status, statusLabels, secondaryText) {
  const percentEl = document.getElementById(`${prefix}-percent`);
  const fillEl = document.getElementById(`${prefix}-meter-fill`);
  const iconEl = document.getElementById(`${prefix}-status-icon`);
  const labelEl = document.getElementById(`${prefix}-status-label`);
  const secondaryEl = document.getElementById(`${prefix}-secondary`);
  if (!percentEl) return;

  const color = STATUS_COLORS[status] || STATUS_COLORS.good;

  percentEl.textContent = percent;
  fillEl.style.width = `${Math.min(percent, 100)}%`;
  fillEl.style.backgroundColor = color;
  iconEl.style.backgroundColor = color;
  labelEl.textContent = statusLabels[status] || status;
  if (secondaryEl) secondaryEl.textContent = secondaryText;
}

async function loadServerMetrics() {
  const block = document.getElementById('server-metrics-block');
  if (!block) return;

  const errorEl = document.getElementById('server-metrics-error');

  try {
    const resp = await fetch('/api/server_metrics/');
    const data = await resp.json();

    if (!data.success) {
      if (errorEl) errorEl.classList.remove('hidden');
      return;
    }
    if (errorEl) errorEl.classList.add('hidden');

    const labels = data.status_labels || {};

    const cpuSecondary = data.cpu.load_avg
      ? `${data.cpu.count} ядер · load average: ${data.cpu.load_avg['1m']}, ${data.cpu.load_avg['5m']}, ${data.cpu.load_avg['15m']}`
      : `${data.cpu.count} ядер`;
    updateMeter('cpu', data.cpu.percent, data.cpu.status, labels, cpuSecondary);

    const memSecondary = `${formatBytes(data.memory.used)} из ${formatBytes(data.memory.total)}`;
    updateMeter('memory', data.memory.percent, data.memory.status, labels, memSecondary);

    const diskSecondary = `${formatBytes(data.disk.used)} из ${formatBytes(data.disk.total)}`;
    updateMeter('disk', data.disk.percent, data.disk.status, labels, diskSecondary);

    const uptimeEl = document.getElementById('server-uptime');
    if (uptimeEl) uptimeEl.textContent = formatUptime(data.uptime_seconds);
  } catch (e) {
    if (errorEl) errorEl.classList.remove('hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const block = document.getElementById('server-metrics-block');
  if (!block) return;

  loadServerMetrics();
  pollTimer = setInterval(loadServerMetrics, POLL_INTERVAL_MS);

  window.addEventListener('beforeunload', () => {
    if (pollTimer) clearInterval(pollTimer);
  });
});
